import { Button, ToastType } from '@components';
import { createSaveConfirmation } from '@components/Button/saveConfirmation';
import { useNavigate, useSearchParams } from '@solidjs/router';
import { openModal } from '@store/modals';
import {
  copyOrder,
  load,
  orderStore,
  resetCarrierStore,
  updateOrderFormErrorState,
} from '@store/orders';
import { userStore } from '@store/user';
import {
  PlusCircleMultipleOutlineIcon,
  ContentSaveIcon,
  FileDocumentIcon,
} from '@atgfr8/icons';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { routeOrderDetailsCopyOrder } from '@utils/routeOrderDetails';
import { handleToast, printError } from '@utils/utils';

import MoreOptions from './MoreOptions';
import { SelectTemplate } from './SelectTemplate';
import { TemplateListModal } from './TemplateListModal';
import { handleHeaderSave } from './helpers';
export function HeaderControl() {
  const [query] = useSearchParams();

  const navigate = useNavigate();
  const { saved, confirmSaved } = createSaveConfirmation();

  const handleCopyOrder = async () => {
    resetCarrierStore();
    await copyOrder();

    if (orderStore.copiedOrderId !== undefined) {
      const isNative = routeOrderDetailsCopyOrder(orderStore.copiedOrderId);
      if (isNative) {
        navigate(`/order/details/?copyOrderId=${orderStore.copiedOrderId}`);
      }
    }

    updateOrderFormErrorState({});
  };

  return (
    <>
      <div
        class="mobile:w-[20%] mobile:pl-2 nonMobile:w-auto flex space-x-2 items-start pl-6 max-h-[40px]"
        style={{
          'align-items': 'anchor-center',
        }}
      >
        {!orderStore.isTemplateMode ? (
          <Button
            startIcon={orderStore.isMobile ? '' : <ContentSaveIcon size={20} />}
            variant="contained"
            size="sm"
            label="SAVE"
            class="mobile:w-full nonMobile:w-[92px] h-[37px]!"
            // why are we calling validate just to save the order as well
            saved={saved()}
            onClick={async () => {
              try {
                const didSave = await handleHeaderSave(
                  navigate,
                  query.ltlQuoteId as string,
                );
                if (didSave) {
                  confirmSaved();
                }
              } catch (error) {
                printError(error);
                handleToast(
                  ToastType.Error,
                  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                  (error as Error).message ?? 'Failed to save order',
                );
              }
            }}
            type="submit"
            isLoading={orderStore.isSaving}
            disabled={
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              ((load()?.forceCarrierChange || load()?.forceCustomerChange) ??
                false) ||
              orderStore.isSaving ||
              orderStore.isSubmittingPickup ||
              (orderStore.order.id != 0 && orderStore.isReadOnly) ||
              (orderStore.order.id != 0 &&
                Boolean(orderStore.orderLockEnabled) &&
                (orderStore.lockedBy?.id ?? -1) !== userStore.user.id) ||
              orderStore.isReadOnly
            }
            sx={{ width: '92px !important', 'margin-right': '16px' }}
            dataTestId={formatDataTestId('SAVE', 'button')}
          />
        ) : null}
        <div class="hidden 1080p:block">
          <Button
            startIcon={<PlusCircleMultipleOutlineIcon size={20} />}
            label="Copy Order"
            disabled={orderStore.order.id === 0}
            size="sm"
            variant="outlined"
            class="whitespace-nowrap h-[37px]!"
            onClick={() => handleCopyOrder()}
            dataTestId={formatDataTestId('Copy Order', 'button')}
          />
        </div>
        <div class="mobile:hidden nonMobile:flex">
          <MoreOptions onCopyOrder={handleCopyOrder} />
        </div>
        <div class="mobile:hidden nonMobile:block">
          <SelectTemplate disabled={orderStore.isTemplateMode} />
        </div>
        <div class="mobile:hidden nonMobile:block">
          <Button
            startIcon={<FileDocumentIcon size={20} />}
            label="Templates"
            size="sm"
            onClick={() => openModal('orderTemplateModal')}
            class="py-1! px-2! w-[130px] ml-2! h-[37px]!"
            color="info"
            sx={{ width: '121px' }}
            dataTestId={formatDataTestId('Templates', 'button')}
          />
        </div>
      </div>
      <TemplateListModal />
    </>
  );
}
